/* eslint-disable */

import { observable, computed, reaction } from 'mobx';
import { store } from '../stores/mainStore';
import { integration } from '../integration';
import { history } from '../history';
import {UI} from './UI';

export class Manager {
	constructor() {
		console.log('new manager', this);
		this.music = null;
		this.init();
		console.log('MANAGER INIT');
	}

	init = () => {
		if (this.sceneRestarting === true) return;

		this.config = null;
		this.game = null;
		this.scene = null;
		this.createScene = null;

		this.diceHand = null;
		this.handHelp = null;
		this.skipTutorial = null;

		this.gameHudLevelText = null;
		this.handPointerTimer = null;
		this.cupSwirlTimer = null;
		this.cupNoticeMeTimer = null;
		this.rollBannerTimer = null;

		this.assetURL = '/assets';
		this.scoreCardOpponentHands = [];
		this.scoreCardBrownCirclePointsHands = [];
		this.scoreCardBrownCirclePointsOpponentHands = [];
		this.pinkHeart = null;
		this.heartText = null;
		this.heartArea = null;
		this.text = null;
		this.rollInfo = null;
		this.handText = null;
		this.arrow = null;
		this.readyToLaunch = false;
		this.gameFlowObserver = null;
		this.observer2 = null;
		this.observer3 = null;
		this.soundObserver = null;
		//this.diceTinyScale = 0.1 * 2;// * (128/256);

		this.hands = {
			1:		'high-hand'       ,
			2:		'pair'            ,
			3:		'two-pair'        ,
			4:		'three-of-a-kind' ,
			5:		'straight'        ,
			6:		'flush'           ,
			7:		'full-house'      ,
			8:		'four-of-a-kind'  ,
			9:		'five-of-a-kind'  ,
			10:		'six-of-a-kind'   ,
			11:		'straight-flush'  ,
			12:		'royal-flush',
			21:		'three-pair',
			22:		'four-pair',
			31:		'three-straight',
			32:		'four-straight',
			41:		'big-house',
			42:		'two-three-of-a-kind',
			51:		'three-straight-flush',
			52:		'four-straight-flush',
			61:		'all-black',
			62:		'all-red',
			63:		'five-flush-diamonds',
			64:		'five-flush-hearts',
			65:		'five-flush-spades',
			66:		'five-flush-clubs'
		};
		
		this.handBannerHandNames = ["blank",
			'three-straight-flush',
			'two-pair',
			'three-of-a-kind',
			'four-straight',
			'straight',
			'flush',
			'full-house',
			'three-pair',
			'five-flush-clubs',
			'five-flush-spades',
			'five-flush-hearts',
			'five-flush-diamonds',
			'two-three-of-a-kind',
			'all-red',
			'all-black',
			'four-straight-flush',
			'four-of-a-kind',
			'straight-flush',
			'royal-flush',
			'highest-hand'
		];
	   //this.dicePerHandType = [0, 3, 4, 3, 4, 5, 5, 5, 6, 5, 5, 5, 5, 6, 9, 9, 4, 4, 5, 5, 9];
	   this.dicePerHandType = [0, 3, 4, 3, 4, 5, 5, 5, 6, 5, 5, 5, 5, 6, 5, 5, 4, 4, 5, 5, 9];

		this.scoreCardContainer = null;
		this.scoreCardBkg = null;
		this.scoreCardHeader = null;
		this.scoreCardFooter = null;
		this.scoreCardFooterOverlay = null;
		this.bannerContainer = null;
		this.resultsBanner = null;
		this.scoreCardBanner = null;
		this.lowerBonusLeft = null;
		this.lowerBonusRight = null;
		this.upperBonusLeft = null;
		this.upperBonusRight = null;
		this.finalScoreLeft = null;
		this.finalScoreRight = null;
		this.lastScoreLeft = null;
		this.lastScoreRight = null;
		this.turnScoresLeft = [];
		this.turnScoresRight = [];
		this.pLeft = null;
		this.pRight = null;
		this.resultsProfilePic = null;
		this.resultsStarsContainer = null;
		this.opponentResultsStarsContainer = null;
		this.resultsProfileShape = null;
		this.resultsOpponentPic = null;
		this.myMatchName = null;
		this.opponentMatchName = null;
		this.myMatchPic = null;
		this.opponentMatchPic = null;
		this.vs = null;
		this.myLevelStar = null;
		this.opponentLevelStar = null;
		this.myMatchRing = null;
		this.opponentMatchRing = null;
		this.scoreCardTweens = [];
		this.zoomerContainer = null;
		this.avaPanel = null;
		this.lastZoomedDice = 0;
		this.lastZoomerTween = null;
		this.currentHandObserver = null;
		this.diceReceived = false;
		this.matchPanel = null;
		this.matchBlur = null;
		this.goalArrowTween = null;
		this.goalArrowTween2 = null;
		this.handBanner = null;
		this.jackPotText = null;
		this.roundBanner = null;
		this.turnBanner = null;
		this.myTotalScore = 0;
		this.opponentTotalScore = 0;
		this.myLowerBonusScore = 0;
		this.myUpperBonusScore = 0;
		this.opponentLowerBonusScore = 0;
		this.opponentUpperBonusScore = 0;
		this.matchesThisSession = 0;
		this.scorehelp = null;
		this.gameHud = null;
		this.gameHudBackButton = null;
		this.gameHudDropdown = null;
		//this.gameState = 'idle';
		//this.diceStatus = 'resolved';
		this.playfield = null;
		this.playfieldFrame = null;
		this.playfieldHighPosition = 0;
		this.playfieldLowPosition = 0;
		this.playHandButtonPressed = false;
		this.extraRollButtonPressed = false;
		this.levelBeforeDoubleXP = 0;
	};

	sceneRestarting = false;
	sceneNeedsToReload = true;

	calcDimensions = (config) => {
		this.config = config;
		this.landscape = false; //this.config.width > this.config.height;

		this.xAspectDiff = this.config.width / 480;
		this.yAspectDiff = this.config.height / 852;

		this.scaleFactor = 2;
		this.assetScaleFactor = this.config.width / 640;
		this.oldAssetScaleFactor = (480 / 640) * this.scaleFactor;

		this.farthestLaunchPoint = { x: 0, y: config.height };

		this.handBannerPosition = 233;//99 * 2; // this.adjustY(99);
		this.defaultButtonWidth = 130 * 2;
	};

	@observable gameState = 'idle';

	_handPointer;
	set handPointer(anim) {
		if (this._handPointer) {
			this._handPointer.destroy();
		}
		this._handPointer = anim;
	}
	get handPointer() {
		return this._handPointer;
	}

	@computed get readyToRoll() {
		return this.diceHand.diceStatus === 'resolved';
	}

	adjustX(oldX) {
		return oldX * this.xAspectDiff;
	}
	adjustY(oldY) {
		return oldY * this.scaleFactor; // this.yAspectDiff;
	}

	launchGameTable = id => {
		console.log('456 MAN launchGameTable : gs =', this.gameState)
		Promise.all([
			store.getPatterns(),
			store.getPaytable()
		]).then(()=> {
			console.log('456 MAN after ALL : gs =', this.gameState , 'to init')
			this.gameState = 'init';
			this.setGameFlowStates();
			history.push(`/game/${id}/play`);			
		})
	}
	startGame = () => {
		console.log('456 MAN startGame : gs =', this.gameState , 'to creation')
		this.gameState = 'creation';
	}
	setGameFlowStates = () => {
		if(this.gameFlowObserver != null)		this.gameFlowObserver();
		this.gameFlowObserver = reaction(() => this.gameState, (state, prev) => {
			console.log('4561 game state changed to', state.toUpperCase(), 'from', prev.observing.map(v => v.value).join(', '));
			// clear observer of heldIndexes
			if(state !== 'userPlay' && this.observer2 != null)	this.observer2();

			if(state === 'creation') {
				this.onMatchCreation();
			} else if(state === 'assetsLoaded') {
				this.onAssetsLoaded();
			} else if(state === 'prematch') {
				store.sendR7event({event: "loaded", balance: store.balance})
				this.ui.mini3Prematch();
			} else if(state === 'userPlay') {
				store.balanceSyncing = true;
				this.ui.protoUserPlay();
				store.showBetSelector = true;
			} else if(state === 'bet') {
				this.ui.tableClearing();
				store.balanceSyncing = false;
				store.enableBetSelector = false;
				if(store.balance < store.bet) {
					store.sendR7event({event: "out_of_credits", balance: store.balance})
					//this.ui.breakRoll();
				} else {
					// no bet animation
					console.log('9296 set bet :: b =', store.balance, 'bet =', store.bet, 'to =', (store.balance - store.bet))
					store.balance -= store.bet;
					this.gameState = 'startRoll';
				}
			} else if(state === 'startRoll') {
				integration.postMixPanelEvent('dice_roll')
				this.ui.startRolling();
				store.showBalance = false;
				store.showBetSelector = false;
				store.getMatch();
			} else if(state === 'endRoll') {
				store.showBalance = true;
				if(store.activeMatch.currentHand.match.length > 0) {
					console.log('4563 round with hand');
					integration.postMixPanelEvent('player_win')
					this.ui.showWinHand();
				} else {
					console.log('4563 round lost');
					integration.postMixPanelEvent('player_lose')
					this.ui.showLoseHand();
				}	
			} else if(state === 'anticipation') {
				const {pattern, winPlaces} = store.curPattern;
				const diceIndices = pattern.filter(v => winPlaces.includes(v))
				console.log('4563 anticip :: maxL =', pattern.length, 'cur =', diceIndices.length, 'arr =', diceIndices)
				if(diceIndices.length >= pattern.length -1) 
					this.ui.bonusGame.anticipation(diceIndices);
				else 
					this.gameState = 'prebonus'
			} else if(state === 'prebonus') {
				console.log('4563 prebonus check BD =', store.activeMatch.bonusData?.rawData)
				if(store.activeMatch.bonusData) {
					console.log('4563 ---- has bonus game')
					store.showBetSelector = false;
					store.showBalance = false;
					store.pulsePattern = true;
				} else {
					this.gameState = 'endMatch'
				}
			} else if(state === 'toBonusPopup') {
				const is4oak = store.activeMatch.currentHand.handName === 'four-of-a-kind';
				const hasFirstBonus = localStorage.getItem('bonus1_shown') === 'true';
				const hasFirst4oak = localStorage.getItem('oak41_shown') === 'true';
				console.log('4563 prebonus popups :: 4 =', is4oak, 'f4 ', hasFirst4oak, 'fb =', hasFirstBonus)
				if(is4oak && !hasFirst4oak) {
					integration.postMixPanelEvent('bonus_trigger4_first')
					store.show4oakTriggerPopup = true;
				} else if (!is4oak && !hasFirstBonus) {
					integration.postMixPanelEvent('bonus_trigger5_first')
					store.showBonusTriggerPopup = true;
				} else {
					if(is4oak)
						integration.postMixPanelEvent('bonus_trigger4')
					else
						integration.postMixPanelEvent('bonus_trigger5')
					store.showBonusStartPopup = true;
				}
			} else if(state === 'startBonus') {
				store.isAutoroll = false;
				store.sendR7event({event: "autoroll", state: false})
				store.sendR7event({event: "bonus_game_start"})
				this.ui.startBonus();
			} else if(state === 'endBonus') {
				store.sendR7event({event: "bonus_game_end", win: store.bonusPrize})
				store.showBonusEndPopup = true;
				store.showBalance = true;
				this.ui.endBonus();
			} else if(state === 'endMatch') {
				console.log('4563 finalize table')
				//this.ui.tableClearing();
				store.curPattern = {...store.curPattern, winPlaces: [], filled: []};
				store.sendR7event({event: "round_complete", balance: store.balance})

				store.sendSeen().then(() => {
					store.isImmediateRematch = true;
					console.log(' -------- check auto ', store.isAutoroll)
					this.gameState = store.isAutoroll ? 'bet' : 'userPlay';
				})
			}
		})
	}

	onMatchCreation = () => {
		if (this.sceneRestarting) {
			this.scene.scene.restart();
		}

		if (this.createScene) {
			this.createScene();
		} else {
			this.gameState = 'init'
			setTimeout(() => this.gameState = 'creation', 500);
		}
	}
	onAssetsLoaded = () => {
		this.diceInstances = this.scene.add.group();
		this.handNameInstances = this.scene.add.group();
	
		if (this.sceneRestarting === false) {
			this.ui = new UI(this);
		}
		this.ui.protoCreateTable() ;
		store.showBalance = true;
		store.showBetSelector = true;

		store.setSpinner(false);
		this.sceneRestarting = true;
	}

	
	playAudio(name, del=0) {
		if (store.settings.sound && !store.isSkillzInited) {
			console.log(' \t\t PLAY SOUND', name)
			if(del===0)
				window.manager.playAudioSprite(name);
			else 
				setTimeout(window.manager.playAudioSprite, del, name);
		}
	}
	playAudioSprite(name) {
		if (this.scene && this.scene.sound) 
			this.scene.sound.playAudioSprite('sfx', name);
	}

	//phaser sideloading code
	get_filesize(url, callback) {
		var xhr = new XMLHttpRequest();
		xhr.open("HEAD", url, true); // Notice "HEAD" instead of "GET",
									 //  to get only the header
		xhr.onreadystatechange = function() {
			if (this.readyState === this.DONE) {
				callback(parseInt(xhr.getResponseHeader("Content-Length")));
			}
		};
		xhr.send();
	}
	sideLoadSpriteSheet (keyName, asset, obj) {
		let showSize = false;
		if(!this.scene.textures.exists(keyName)) {
			if(showSize) {
				window.manager.get_filesize(asset, function(size) {
					console.log('SIDELOADING SPRITESHEET: '+asset+'\t\t SIZE: '+size);
					window.manager.scene.load.once('complete', window.manager.processSideLoading);
					window.manager.scene.load.spritesheet(keyName, asset, obj);
					window.manager.scene.load.start();
				});
			} else {
				console.log('SIDELOADING SPRITESHEET: '+keyName);
				// store.debug = 'SIDELOADING: '+keyName;
				window.manager.scene.load.once('complete', window.manager.processSideLoading);
				window.manager.scene.load.spritesheet(keyName, asset, obj);
				window.manager.scene.load.start();
			}
		}
	}
	sideLoadImage (keyName, asset) {
		let showSize = false;
		if(!window.manager.scene.textures.exists(keyName)) {
			if(showSize) {
				window.manager.get_filesize(asset, function(size) {
					console.log('SIDELOADING IMAGE: '+asset+'\t\t SIZE: '+size);
					window.manager.scene.load.once('complete', window.manager.processSideLoading);
					window.manager.scene.load.image(keyName, asset);
					window.manager.scene.load.start();
				});
			} else {
				console.log("SIDELOADING IMAGE: "+asset);
				// store.debug = 'SIDELOADING: '+keyName;
				window.manager.scene.load.once('complete', window.manager.processSideLoading);
				window.manager.scene.load.image(keyName, asset);
				window.manager.scene.load.start();
			}
		}
	}
	processSideLoading() {
		if(store.phaserSideLoadImages.length > 0 || store.phaserSideLoadSpriteSheets.length > 0) {
			store.phaserSideLoading = true;
			if(store.phaserSideLoadImages.length > 0) {
				var item = store.phaserSideLoadImages.pop();
				window.manager.sideLoadImage(item.keyName, item.asset);
				return;
			}
			if(store.phaserSideLoadSpriteSheets.length > 0) {
				var item = store.phaserSideLoadSpriteSheets.pop();
				window.manager.sideLoadSpriteSheet(item.keyName, item.asset, item.obj);
				return;
			}
		} else {
			store.phaserSideLoading = false;
			// store.debug = 'SIDELOADING COMPLETE';
		}
	}
	startSideLoading() {
		if(store.phaserSideLoading)
			return;
		if(store.phaserSideLoadImages.length > 0 || store.phaserSideLoadSpriteSheets.length > 0) {
			store.phaserSideLoading = true;
			this.processSideLoading();
		}
	}
}